<template>
  <div class="block">
    <div>
      <span class="title">权限信息：</span>
      <el-radio-group v-model="id">
        <el-radio :label="'00001'">机关管理员</el-radio>
        <el-radio :label="'00002'">党组织管理员</el-radio>
        <el-radio :label="'00003'">单位管理员</el-radio>
        <el-radio :label="'0'">普通用户</el-radio>
      </el-radio-group>
    </div>
    <div v-show="showExtra">
      <span class="title">所属{{belong}}：</span>
      <el-cascader
        class="cascader"
        :options="options"
        :show-all-levels="false"
        :props="{ checkStrictly: true }"
        clearable
        v-model="activeList"
      ></el-cascader>
    </div>
  </div>
</template>
<script>
import { BaseVue } from "@/mixin/index";
import { getCompanyInfoApi, getPartyInfoApi } from "@/api/module/muser/muser";

export default {
  name: "MuserTypeSelect",
  
  mixins: [BaseVue],
  
  props: {
    muserType: {
      type: String,
      default: ""
    }
  },
  
  data() {
    return {
      id: '',
      unitid: '',
      partyorgid: '',
      options: [],
      activeList: "" // 选中的项
    };
  },
  
  computed: {
    belong() {
      if (this.id == "00002") {
        return "党组织";
      } else if (this.id == "00003") {
        return "单位";
      } else {
        return "";
      }
    },
    
    showExtra() {
      if (this.id == "00002") {
        return true;
      } else if (this.id == "00003") {
        return true;
      } else {
        return false;
      }
    }
  },
  
  methods: {
    // 获取单位级联
    getCompanyInfo() {
      getCompanyInfoApi()
        .then((res) => {
          this.options = res;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    
    // 获取党组织级联
    getPartyInfo() {
      getPartyInfoApi()
        .then((res) => {
          this.options = res;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    
    //
    // init
    //
    init(data) {
      // 调用机关管理员接口的位置
      console.log("data init", data);
      
      this.id = data.roleid;
      this.unitid = data.unitid;
      this.partyorgid = data.partyorgid;
      this.activeList = data.unitid || data.partyorgid;
    },
    
    //
    // emit
    //
    onDataChanged() {
      let data = {
        role: this.id,
        rid: this.activeList
      };
      this.$emit("onDataChanged", data);
    }
  },
  
  watch: {
    activeList() {
      this.onDataChanged();
    },
    
    id(newVal) {
      if (newVal == "00002") {
        this.getPartyInfo();
      } else if (newVal == "00003") {
        this.getCompanyInfo();
      }
      this.onDataChanged();
    }
  },
  
  created() {
    console.log("muser type select new");
    // this.getPartyInfo();
  }
};
</script>


<style lang="scss" scoped>
.block {
  display: flex;
  flex-direction: column;
  & > div {
    display: flex;
    align-items: center;
    margin-bottom: 20px;
    .title {
      box-sizing: border-box;
      font-size: 13px;
      width: 110px;
      margin-right: 25px;
    }
  }


  .cascader{
    width: 300px;
  }
}
</style>